import Text_vue_vue_type_script_setup_true_lang_default from "./Text.vue_vue_type_script_setup_true_lang.js";
//#region src/views/Chat/Messages/Text.vue
var Text_default = Text_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Text_default as default };

//# sourceMappingURL=Text.vue.js.map